import React from "react";

import { Box, Flex, Text } from "@chakra-ui/react";

import Group from "../../../pages/ServicosAcolhimento/Visualizar/Group";
import { IrmaoTable } from "../../../pages/Criancas/ReferenciaFamiliar/Irmaos/Table";

export const SituacaoJuridica = ({
  data,
  dataVoluntaria,
  dataAtribuicao,
  dataHouveExtincao,
}) => {
  const dataProcesso = data?.filter(
    (item) => item.tipoSituacaoJuridica === "P"
  );

  const dataProcedimento = data?.filter(
    (item) => item.tipoSituacaoJuridica === "D"
  );

  const columnsProcessos = [
    {
      Header: "Nº do Processo",
      accessor: "numeroProcesso",
      Cell: (props) => {
        return (
          <Text whiteSpace={"nowrap"} title={props.value}>
            {props.value}
          </Text>
        );
      },
    },
    {
      Header: "Tipo",
      accessor: "descricaoSituacaoJuridica",
      Cell: (props) => {
        return <Text whiteSpace={"normal"}>{props?.value}</Text>;
      },
    },
    {
      Header: "Sentença",
      accessor: "sentenca",
      Cell: (props) => {
        return (
          <span>
            {props.value === "S"
              ? "Sim"
              : props.value === "N"
              ? "Não"
              : "Não se Aplica"}
          </span>
        );
      },
    },
    {
      Header: "Tipo de Sentença",
      accessor: "descricaoTipoSentenca",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props?.value}</Text>;
      },
    },
    {
      Header: "Trânsito julgado",
      accessor: "transitoJulgado",
      Cell: (props) => {
        return (
          <span>
            {props.value === "S"
              ? "Sim"
              : props.value === "N"
              ? "Não"
              : "Não se Aplica"}
          </span>
        );
      },
    },
  ];

  const columnsProcedimentos = [
    {
      Header: "Nº do Procedimento",
      accessor: "numeroProcesso",
      Cell: (props) => {
        return (
          <Text whiteSpace={"nowrap"} title={props.value}>
            {props.value}
          </Text>
        );
      },
    },
    {
      Header: "Tipo",
      accessor: "descricaoSituacaoJuridica",
      Cell: (props) => {
        return <Text whiteSpace={"normal"}>{props?.value}</Text>;
      },
    },
    {
      Header: "Sentença",
      accessor: "sentenca",
      Cell: (props) => {
        return (
          <span>
            {props.value === "S"
              ? "Sim"
              : props.value === "N"
              ? "Não"
              : "Não se Aplica"}
          </span>
        );
      },
    },
    {
      Header: "Tipo de Sentença",
      accessor: "descricaoTipoSentenca",
      Cell: (props) => {
        return <Text whiteSpace={"nowrap"}>{props?.value}</Text>;
      },
    },
    {
      Header: "Trânsito julgado",
      accessor: "transitoJulgado",
      Cell: (props) => {
        return (
          <span>
            {props.value === "S"
              ? "Sim"
              : props.value === "N"
              ? "Não"
              : "Não se Aplica"}
          </span>
        );
      },
    },
  ];

  const columnsEntregaVisualizar = [
    {
      Header: "Houve Extinção do Poder Familiar?",
      accessor: "extincaoPoderFamilia",
      Cell: (props) => {
        return (
          <span>
            {props.value === "S"
              ? "Sim"
              : props.value === "N"
              ? "Não"
              : props.value === "A"
              ? "Aguardando Prazo"
              : ""}
          </span>
        );
      },
      disableSortBy: true,
    },
    {
      Header: (props) => {
        return (
          <span title={props.column.id}>
            {`Nº do ${
              props?.data[0]?.tipoSituacaoJuridica === "P"
                ? "Processo"
                : "Procedimento"
            }`}
          </span>
        );
      },
      accessor: "numeroProcesso",
      Cell: (props) => {
        return (
          <Text whiteSpace={"nowrap"} title={props.value}>
            {props.value}
          </Text>
        );
      },
      disableSortBy: true,
    },

    {
      Header: "Tipo",
      accessor: "descricaoSituacaoJuridica",
      Cell: (props) => {
        return <Text>{props.value}</Text>;
      },
      disableSortBy: true,
    },
  ];

  const EntregaVoluntaria = () => (
    <Box className="break-page">
      <Group
        bgColor="#fff"
        title="ENTREGA VOLUNTÁRIA"
        py="12px"
        mtDivider="5px"
      >
        {dataVoluntaria && [dataVoluntaria].length > 0 ? (
          <>
            <Box py="1" mt={6} px={6} bgColor={"#DDEBEA"}>
              <Text fontWeight={"700"} color={"gray.600"}>
                Processos/Procedimentos
              </Text>
            </Box>

            <IrmaoTable
              disableHeaderOptions={true}
              mt={"0px"}
              columns={columnsEntregaVisualizar}
              data={[dataVoluntaria]}
              filiacoes={[dataVoluntaria]}
              entidade="entrega"
              entrega={true}
            />
          </>
        ) : (
          <Box mt={6}>
            <Text as="b">Houve Extinção do Poder Familiar?</Text>
          </Box>
        )}
      </Group>
    </Box>
  );

  return dataAtribuicao ? (
    <>
      <Box className="break-page">
        <Flex>
          <Group
            bgColor="#fff"
            title="ATRIBUIÇÃO E COMPETÊNCIA"
            py="12px"
            mtDivider="5px"
          >
            <>
              <Flex mt={4} alignItems="center" gap={8}>
                <Text as="b">Promotoria de Justiça com Atribuição:</Text>

                <Text whiteSpace="nowrap" color="#169499">{`${
                  dataAtribuicao?.tipoAtribuicaoPromotoria === "A"
                    ? "Definição Automática"
                    : dataAtribuicao?.tipoAtribuicaoPromotoria === "M"
                    ? "Definição Manual"
                    : ""
                } `}</Text>
              </Flex>

              <Text mt={2}>{dataAtribuicao?.nomePromotoria}</Text>
              <Flex mt={6} alignItems="center" gap={8}>
                <Text as="b">Vara da Infância Competente:</Text>

                <Text whiteSpace="nowrap" color="#169499">{`${
                  dataAtribuicao?.tipoAtribuicaoVara === "A"
                    ? "Definição Automática"
                    : dataAtribuicao?.tipoAtribuicaoVara === "M"
                    ? "Definição Manual"
                    : ""
                } `}</Text>
              </Flex>
              <Text mt={2}>{dataAtribuicao?.nomeVara}</Text>
            </>
          </Group>
        </Flex>
      </Box>
      <Box className="break-page">
        <Flex>
          <Group
            bgColor="#fff"
            title="PROCESSOS E PROCEDIMENTOS"
            py="12px"
            mtDivider="5px"
          >
            {dataProcesso && dataProcesso.length > 0 && (
              <>
                <Box py="1" px={6} bgColor={"#DDEBEA"}>
                  <Text fontWeight={"700"} color={"gray.600"}>
                    Processos
                  </Text>
                </Box>
                <IrmaoTable
                  disableHeaderOptions={true}
                  mt={"0px"}
                  columns={columnsProcessos}
                  data={data?.filter(
                    (item) => item.tipoSituacaoJuridica === "P"
                  )}
                  filiacoes={data?.filter(
                    (item) => item.tipoSituacaoJuridica === "P"
                  )}
                  entidade="processos"
                  processos={true}
                />
              </>
            )}

            {dataProcedimento && dataProcedimento.length > 0 && (
              <>
                <Box mt={10} py="1" px={6} bgColor={"#DDEBEA"}>
                  <Text fontWeight={"700"} color={"gray.600"}>
                    Procedimentos
                  </Text>
                </Box>
                <IrmaoTable
                  disableHeaderOptions={true}
                  mt={"0px"}
                  columns={columnsProcedimentos}
                  data={data?.filter(
                    (item) => item.tipoSituacaoJuridica === "D"
                  )}
                  filiacoes={data?.filter(
                    (item) => item.tipoSituacaoJuridica === "D"
                  )}
                  entidade="procedimentos"
                  procedimentos={true}
                />
              </>
            )}
          </Group>
        </Flex>
      </Box>
      {dataHouveExtincao && <EntregaVoluntaria />}
    </>
  ) : (
    <>
      {" "}
      <Box className="break-page">
        <Flex>
          <Group
            bgColor="#fff"
            title="PROCESSOS E PROCEDIMENTOS"
            mt="15px"
            py="12px"
            mtDivider="5px"
          />
        </Flex>
      </Box>
      {dataHouveExtincao && <EntregaVoluntaria />}
    </>
  );
};
